<template>
        <div id='pointsdetail'>
              <NavTop title='积分明细'/>
              <div class='content'>
                    <div class="row">
                       <div class="col-title">时间</div>
                       <div class="col-title">类型</div>
                       <div class="col-title">来源</div>
                       <div class="col-title">积分</div>
                    </div>
                    <div class="row" v-for="item in list" :key="item.id">
                       <div class="col">{{item.datetime}}</div>
                       <div class="col">{{item.typename}}</div>
                       <div class="col">{{item.from}}</div>
                       <div class="col">{{item.points}}</div>
                    </div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
export default {
  data(){
      return{
         list:{}
      }
  },  
  name: 'pointsdetail',
  created(){
     this.getList()
  },
  methods:{
     getList(){
        if(this.$route.params.type==undefined || this.$route.params.ptype==undefined){
             this.$toast("页面参数有误，请稍后再试")
             return false
        } 
        this.$post("/prize/getPointsDetail",{type:this.$route.params.type,ptype:this.$route.params.ptype}).then((data)=>{
               if(data.result.success){
                  this.list=data.result.info
               }else{
                  this.$toast(data.result.info)
               }
         })   
     }
  },
  components:{
      NavTop
  }
}
</script>
<style scoped>
#pointsdetail{background-color:#F6F6F6;min-height: 100vh;padding: 0.2rem;}
.content{background-color: #fff;border-radius: 0.2rem;padding: 0.1rem 0.1rem;}
.row{display: flex;flex-flow: row nowrap;border-bottom: 1px dashed #eee;padding: 0.1rem;align-items: center;}
.col-title{font-size:0.38rem;flex:1;}
.col{font-size:0.35rem;flex:1;}
</style>


